module.exports = __webpack_public_path__ + "img/3e6ca4d.svg";